import { render, staticRenderFns } from "./bimPreview.vue?vue&type=template&id=28e2159f&scoped=true"
import script from "./bimPreview.vue?vue&type=script&lang=js"
export * from "./bimPreview.vue?vue&type=script&lang=js"
import style0 from "./bimPreview.vue?vue&type=style&index=0&id=28e2159f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e2159f",
  null
  
)

export default component.exports